import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import classNames from "classnames";
import classes from './banner.module.scss';
import { motion } from "framer-motion";


const slides = [
  {
    image: "/images/banner9.jpg",
    preTitle: "همراه",
    title: "خورشید جاده ابریشم",
    description: "طعم واقعی قهوه را احساس کنید",
    link: "/products",
    buttonText: "محصولات",
  },
  {
    image: "/images/banner4.jpg",
    title: "",
    description: "",
    link: "/coffee/drinks",
    buttonText: "وبلاگ",
  },
  {
    image: "/images/banner7.jpg",
    title: "",
    description: "",
    link: "/about",
    buttonText: "درباره ما",
  },
  {
    image: "/images/banner10.jpg",
    preTitle: "با",
    title: "SilkRoad",
    description: " صبحی تازه آغاز کنید",
    link: "/products",
    buttonText: "محصولات",
  },
];

const BannerSlider = ({ scrollToProducts }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: "easeOut" },
    },
  };

  const imageVariants = {
    hidden: { scale: 1.05, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: { duration: 1.2, ease: "easeOut" },
    },
  };


  return (
    <div className="relative w-full h-screen md:h-[80vh] overflow-hidden">
      <Swiper
        modules={[Navigation, Autoplay, Pagination]}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
          swiper.navigation.init();
          swiper.navigation.update();
        }}
        // pagination={{ clickable: true }}
        autoplay={{ delay: 30000 }}
        loop
        className={classNames("w-full h-full", classes.customSwiper)}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="w-full h-full relative flex items-center justify-end overflow-hidden">

              {/* Motion Image */}
              <motion.img
                initial="hidden"
                animate="visible"
                variants={imageVariants}
                src={slide.image}
                alt={slide.title}
                className={classNames(
                  "absolute top-0 left-0 w-full h-full object-cover md:object-contain object-center",
                  classes.animateBanner
                )}
              />

              {/* Black fade bottom */}
              <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-l from-black/80 via-black/40 to-transparent z-10" />

              {/* Motion Text Box */}
              <motion.div
                initial="hidden"
                animate="visible"
                variants={textVariants}
                className="absolute bottom-6 right-6 z-20 text-right max-w-lg px-6"
              >
                <div className="text-gray-200 text-2xl font-extrabold mb-2">{slide?.preTitle}</div>
                <h2 className="text-white text-3xl font-extrabold mb-2">{slide.title}</h2>
                <p className="text-gray-200 text-xl mb-4">{slide.description}</p>

                {slide.buttonText === "محصولات" ? (
                  <button
                    onClick={scrollToProducts}
                    className="inline-block px-5 py-2 tracking-wide bg-gradient-to-r from-[#FF8C42] via-[#FF6F00] to-[#D18F00] text-white rounded hover:bg-orange-600 transition"
                  >
                    {slide.buttonText}
                  </button>
                ) : (
                  <a
                    href={slide.link}
                    className="inline-block px-5 py-2 tracking-wide bg-gradient-to-r from-[#FF8C42] via-[#FF6F00] to-[#D18F00] text-white rounded hover:bg-orange-600 transition"
                  >
                    {slide.buttonText}
                  </a>
                )}
              </motion.div>
            </div>
          </SwiperSlide>
        ))}

        {/* Custom Navigation Arrows */}
        <button
          ref={prevRef}
          className="absolute z-30 top-1/2 -translate-y-1/2 right-4 tracking-wide bg-gradient-to-r from-[#FF8C42] via-[#FF6F00] to-[#D18F00]  text-white w-10 h-10 rounded-full flex items-center justify-center shadow-lg hover:scale-105 transition"
        >
          ‹
        </button>
        <button
          ref={nextRef}
          className="absolute z-30 top-1/2 -translate-y-1/2 left-4 tracking-wide bg-gradient-to-r from-[#FF8C42] via-[#FF6F00] to-[#D18F00] text-white w-10 h-10 rounded-full flex items-center justify-center shadow-lg hover:scale-105 transition"
        >
          ›
        </button>
      </Swiper>
    </div>
  );
};

export default BannerSlider;
